import React, { useEffect, useRef, useState } from "react";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

export default function Dashboard({ sessionToken = "", currentUser = null, onSessionExpired = () => {} }) {
	const AUTOSAVE_KEY = "zeytinhesap_autosave";
	const DRAFT_KEY = "zeytinhesap_draft";
	const API_BASE_URL = "http://localhost:4000/api/v1";

	const [activeTab, setActiveTab] = useState("hesap");
	const [sellerName, setSellerName] = useState("");
	const [sellerPhone, setSellerPhone] = useState("");
	const [sellerOliveType, setSellerOliveType] = useState("");
	const [deliveries, setDeliveries] = useState([]);
	const [selectedDeliveryListId, setSelectedDeliveryListId] = useState("");
	const [deliveryAddInfo, setDeliveryAddInfo] = useState("");
	const [sellerAddInfo, setSellerAddInfo] = useState("");
	const [selectedSellerId, setSelectedSellerId] = useState("");
	const [lastAddedSellerId, setLastAddedSellerId] = useState(null);
	const [isHistoryOpen, setIsHistoryOpen] = useState(false);
	const [expenses, setExpenses] = useState([]);
	const [expenseDesc, setExpenseDesc] = useState("");
	const [expenseAmount, setExpenseAmount] = useState("");
	const [teslimatlar, setTeslimatlar] = useState([]);
	const [teslimatFirma, setTeslimatFirma] = useState("");
	const [teslimatKasa, setTeslimatKasa] = useState("");
	const [teslimatCesit, setTeslimatCesit] = useState("");
	const [teslimatKg, setTeslimatKg] = useState("");
	const [teslimatFiyat, setTeslimatFiyat] = useState("");
	const [selectedTeslimatKaydiId, setSelectedTeslimatKaydiId] = useState("");
	const [kasaDusAdedi, setKasaDusAdedi] = useState("1");
	const [isAccountTableLocked, setIsAccountTableLocked] = useState(false);
	const [reportOliveType, setReportOliveType] = useState("");
	const [clockNow, setClockNow] = useState(new Date());
	const [lastAutoSave, setLastAutoSave] = useState(() => {
		try {
			const saved = localStorage.getItem(AUTOSAVE_KEY);
			if (saved) {
				const parsed = JSON.parse(saved);
				return parsed.savedAt || null;
			}
		} catch {}
		return null;
	});
	const [savedSnapshot, setSavedSnapshot] = useState(() => {
		try {
			const saved = localStorage.getItem(AUTOSAVE_KEY);
			if (saved) return JSON.parse(saved);
		} catch {}
		return null;
	});
	const [lastPeriodicSaveAt, setLastPeriodicSaveAt] = useState(null);
	const [showSellerSuggestions, setShowSellerSuggestions] = useState(true);
	const [isAdmin, setIsAdmin] = useState(false);
	const [members, setMembers] = useState(() => {
		try {
			const saved = localStorage.getItem("zeytinhesap_members");
			if (saved) return JSON.parse(saved);
		} catch {}
		return [];
	});
	const [adminView, setAdminView] = useState("list"); // "list" | "addMember" | "payment"
	const [selectedAdminMemberId, setSelectedAdminMemberId] = useState(null);
	const [memberForm, setMemberForm] = useState({ name: "", phone: "", email: "" });
	const [paymentAmount, setPaymentAmount] = useState("");
	const [paymentDays, setPaymentDays] = useState("");
	const dropdownRef = useRef(null);
	const formatDateKeyLocal = (date) => {
		const year = date.getFullYear();
		const month = String(date.getMonth() + 1).padStart(2, "0");
		const day = String(date.getDate()).padStart(2, "0");
		return `${year}-${month}-${day}`;
	};
	const [dailyReportDate, setDailyReportDate] = useState(() => formatDateKeyLocal(new Date()));
	const classNames = ["Duble", "No:1", "No:2", "No:3", "No:4", "Yağlık"];
	const oliveTypes = ["Trilya", "Edremit", "Uslu", "Domat", "Tekir"];
	const [accountRows, setAccountRows] = useState(
		classNames.map((name) => ({ name, kg: "", price: "" }))
	);
	const [reportRows, setReportRows] = useState(
		classNames.map((name) => ({ name, kg: "", price: "" }))
	);
	const [olivePurchaseRows, setOlivePurchaseRows] = useState(
		oliveTypes.map((name) => ({ name, kg: "", price: "" }))
	);
	const [sellers, setSellers] = useState([
		{ id: 1, name: "Ahmet Yılmaz", phone: "0507 111 22 33" },
		{ id: 2, name: "Ayşe Korkmaz", phone: "0534 101 20 30" },
		{ id: 3, name: "Burak Öztürk", phone: "0535 202 30 40" },
		{ id: 4, name: "Cem Arslan", phone: "0536 303 40 50" },
		{ id: 5, name: "Mehmet Kaya", phone: "0532 444 55 66" },
		{ id: 6, name: "Hasan Demir", phone: "0541 888 11 22" },
		{ id: 7, name: "Ali Çelik", phone: "0553 222 33 44" },
	]);

	const tabs = [
		{ key: "hesap", label: "Hesaplama" },
		{ key: "rapor", label: "Raporlar" },
		{ key: "gider", label: "Kayıt" },
	];

	const sellerHistory = {
		1: [
			{ date: "12.03.2026", type: "Trilya", kg: 320, paid: "30.976 TL" },
			{ date: "06.03.2026", type: "Edremit", kg: 210, paid: "19.845 TL" },
			{ date: "28.02.2026", type: "Domat", kg: 155, paid: "14.260 TL" },
		],
		2: [
			{ date: "11.03.2026", type: "Tekir", kg: 180, paid: "16.920 TL" },
			{ date: "03.03.2026", type: "Trilya", kg: 245, paid: "23.765 TL" },
		],
		3: [
			{ date: "09.03.2026", type: "Uslu", kg: 140, paid: "12.880 TL" },
			{ date: "25.02.2026", type: "Edremit", kg: 195, paid: "18.330 TL" },
		],
		4: [
			{ date: "10.03.2026", type: "Domat", kg: 165, paid: "15.015 TL" },
			{ date: "01.03.2026", type: "Tekir", kg: 120, paid: "11.160 TL" },
		],
		5: [
			{ date: "14.03.2026", type: "Trilya", kg: 355, paid: "34.435 TL" },
			{ date: "05.03.2026", type: "Uslu", kg: 205, paid: "18.655 TL" },
		],
		6: [
			{ date: "08.03.2026", type: "Edremit", kg: 190, paid: "17.860 TL" },
			{ date: "23.02.2026", type: "Domat", kg: 130, paid: "11.960 TL" },
		],
		7: [
			{ date: "07.03.2026", type: "Tekir", kg: 175, paid: "16.450 TL" },
			{ date: "24.02.2026", type: "Trilya", kg: 150, paid: "14.550 TL" },
		],
	};

	const normalizeTurkishUpperText = (value) => {
		const upper = String(value || "").toLocaleUpperCase("tr-TR");
		return upper.replace(/[^A-ZÇĞİÖŞÜ\s]/g, "").replace(/\s+/g, " ").trimStart();
	};

	const normalizePhoneForCompare = (value) => String(value || "").replace(/\D/g, "");

	const handleAddSeller = () => {
		const normalizedSellerName = normalizeTurkishUpperText(sellerName).trim();
		const normalizedSellerPhone = normalizePhoneForCompare(sellerPhone);
		if (!normalizedSellerName || !normalizedSellerPhone) {
			setSellerAddInfo("Ad Soyad ve Telefon gerekli.");
			return;
		}

		const isDuplicateSeller = sellers.some(
			(seller) => normalizePhoneForCompare(seller.phone) === normalizedSellerPhone
		);

		if (isDuplicateSeller) {
			const wantsCreate = window.confirm(
				"Bu telefon numarasi zaten kayitli. Yeni kayit olusturulsun mu?"
			);
			if (!wantsCreate) {
				setSellerAddInfo("Kayit iptal edildi.");
				window.setTimeout(() => setShowSellerSuggestions(false), 2000);
				return;
			}
		}

		const newSellerId = Date.now();
		const nextSellers = [
			{
				id: newSellerId,
				name: normalizedSellerName,
				phone: sellerPhone.trim(),
				oliveType: sellerOliveType,
			},
			...sellers,
		];

		saveAutoSnapshot({ sellers: nextSellers });
		setSellers(nextSellers);
		setLastAddedSellerId(newSellerId);
		setSellerAddInfo("Satıcı eklendi ve otomatik kaydedildi.");
		setSellerName("");
		setSellerPhone("");
		setSellerOliveType("");
	};

	const handleSelectSellerSuggestion = (seller) => {
		setSellerName(normalizeTurkishUpperText(seller.name));
		setSellerPhone(seller.phone || "");
		if (seller.oliveType) {
			setSellerOliveType(seller.oliveType);
		}
		setShowSellerSuggestions(false);
	};

	const handleSellerOliveTypeChange = (value) => {
		setSellerOliveType(value);
		setSelectedSellerId("");
	};

	const handleAddDelivery = () => {
		const autoDeliveryName = tradeSellerName ? tradeSellerName : "Satıcı girilmedi";
		const autoDeliveryType = tradeOliveType ? tradeOliveType : "Çeşit girilmedi";
		const autoDeliveryKg = totalKg;
		const now = new Date();
		const classBreakdownForDelivery = classNames.map((className) => {
			const row = accountRows.find((r) => r.name === className);
			return {
				name: className,
				kg: row ? row.kg : "",
				price: row ? row.price : "",
			};
		});

		if (!autoDeliveryKg || autoDeliveryKg <= 0) {
			return false;
		}

		setDeliveries((currentDeliveries) => [
			{
				id: Date.now(),
				createdAt: now.toISOString(),
				dayKey: formatDateKeyLocal(now),
				name: autoDeliveryName,
				oliveType: autoDeliveryType,
				kg: autoDeliveryKg,
				classBreakdown: classBreakdownForDelivery,
			},
			...currentDeliveries,
		]);
		setSelectedDeliveryListId("");
		return true;
	};

	const handleAddDeliveryClick = () => {
		const isSaved = handleAddDelivery();
		setDeliveryAddInfo(isSaved ? "Teslim kaydı eklendi." : "Teslim kg 0 oldugu icin kaydedilemedi.");
	};

	const selectedSeller = sellers.find((seller) => String(seller.id) === selectedSellerId);
	const lastAddedSeller = sellers.find((seller) => seller.id === lastAddedSellerId);
	const normalizedSellerSearch = normalizeTurkishUpperText(sellerName).trim();
	const similarSellerSuggestions =
		normalizedSellerSearch.length >= 2
			? sellers
					.filter((seller) =>
						normalizeTurkishUpperText(seller.name).includes(normalizedSellerSearch)
					)
					.slice(0, 5)
			: [];
	const currentTradeSeller = selectedSeller || lastAddedSeller;
	const tradeSellerName = selectedSeller
		? selectedSeller.name
		: sellerName.trim() || (currentTradeSeller ? currentTradeSeller.name : "");
	const tradeOliveType = selectedSeller
		? selectedSeller.oliveType || ""
		: sellerOliveType || (currentTradeSeller ? currentTradeSeller.oliveType || "" : "");
	const selectedSellerHistory = selectedSeller ? sellerHistory[selectedSeller.id] || [] : [];

	const parseNumber = (value) => {
		const normalized = String(value).replace(",", ".").trim();
		const parsed = Number(normalized);
		return Number.isFinite(parsed) ? parsed : 0;
	};

	const toUiPayment = (payment) => ({
		id: payment.id,
		amount: Number(payment.amount || 0),
		durationDays: Number(payment.duration_days ?? payment.durationDays ?? 0),
		paidAt: payment.paid_at || payment.paidAt || new Date().toISOString(),
	});

	const toUiMember = (member) => ({
		id: member.id,
		name: member.name || "",
		phone: member.phone || "",
		email: member.email || "",
		registeredAt: member.registered_at || member.registeredAt || new Date().toISOString(),
		expiresAt: member.expires_at || member.expiresAt || null,
		payments: Array.isArray(member.payments) ? member.payments.map(toUiPayment) : [],
	});

	const toUiExpense = (item) => ({
		id: item.id,
		desc: item.desc || "",
		amount: Number(item.amount || 0),
	});

	const toUiTeslimat = (item) => ({
		id: item.id,
		firma: item.firma || "",
		kasa: item.kasa ?? "",
		cesit: item.cesit || "",
		kg: Number(item.kg || 0),
		fiyat: Number(item.fiyat || 0),
	});

	const apiRequest = async (path, options = {}) => {
		if (!sessionToken) throw new Error("API oturumu acik degil");

		const response = await fetch(`${API_BASE_URL}${path}`, {
			...options,
			headers: {
				"Content-Type": "application/json",
				Authorization: `Bearer ${sessionToken}`,
				...(options.headers || {}),
			},
		});

		if (response.status === 401) {
			onSessionExpired();
			throw new Error("Oturum suresi doldu");
		}

		if (!response.ok) {
			const errData = await response.json().catch(() => ({}));
			throw new Error(errData.error || "API hatasi");
		}

		if (response.status === 204) return null;
		return response.json();
	};

	const formatMoney = (value) => {
		if (!value) {
			return "";
		}
		return `₺${value.toLocaleString("tr-TR", { maximumFractionDigits: 2 })}`;
	};

	const applySnapshotData = (data) => {
		if (!data) return;
		if (Array.isArray(data.deliveries)) setDeliveries(data.deliveries);
		if (Array.isArray(data.sellers)) setSellers(data.sellers);
		if (Array.isArray(data.expenses)) setExpenses(data.expenses);
		if (Array.isArray(data.teslimatlar)) setTeslimatlar(data.teslimatlar);
		if (Array.isArray(data.accountRows)) setAccountRows(data.accountRows);
		if (typeof data.sellerName === "string") setSellerName(data.sellerName);
		if (typeof data.sellerPhone === "string") setSellerPhone(data.sellerPhone);
		if (typeof data.sellerOliveType === "string") setSellerOliveType(data.sellerOliveType);
		if (typeof data.expenseDesc === "string") setExpenseDesc(data.expenseDesc);
		if (typeof data.expenseAmount === "string") setExpenseAmount(data.expenseAmount);
		if (typeof data.teslimatFirma === "string") setTeslimatFirma(data.teslimatFirma);
		if (typeof data.teslimatKasa === "string") setTeslimatKasa(data.teslimatKasa);
		if (typeof data.teslimatCesit === "string") setTeslimatCesit(data.teslimatCesit);
		if (typeof data.teslimatKg === "string") setTeslimatKg(data.teslimatKg);
		if (typeof data.teslimatFiyat === "string") setTeslimatFiyat(data.teslimatFiyat);
		if (data.savedAt) setLastAutoSave(data.savedAt);
		setSavedSnapshot(data);
	};

	const getRecordDateTime = () => {
		const now = new Date();
		return {
			dateText: now.toLocaleDateString("tr-TR"),
			dayText: now.toLocaleDateString("tr-TR", { weekday: "long" }),
			timeText: now.toLocaleTimeString("tr-TR"),
		};
	};

	const periodicSaveRef = useRef(null);

	const buildSnapshotData = (overrides = {}) => ({
		deliveries,
		sellers,
		expenses,
		teslimatlar,
		accountRows,
		sellerName,
		sellerPhone,
		sellerOliveType,
		expenseDesc,
		expenseAmount,
		teslimatFirma,
		teslimatKasa,
		teslimatCesit,
		teslimatKg,
		teslimatFiyat,
		savedAt: new Date().toISOString(),
		...overrides,
	});

	periodicSaveRef.current = buildSnapshotData;

	useEffect(() => {
		setReportRows((currentRows) =>
			classNames.map((className) => {
				const previousRow = currentRows.find((row) => row.name === className);
				const filteredDeliveries = reportOliveType
					? deliveries.filter((d) => (d.oliveType || "") === reportOliveType)
					: deliveries;
				const totalByClass = filteredDeliveries.reduce((sum, d) => {
					if (d.classBreakdown && Array.isArray(d.classBreakdown)) {
						const matchedClass = d.classBreakdown.find((item) => item.name === className);
						return sum + parseNumber(matchedClass ? matchedClass.kg : 0);
					}
					return sum;
				}, 0);
				return {
					name: className,
					kg: totalByClass ? String(totalByClass) : "",
					price: previousRow ? previousRow.price : "",
				};
			})
		);
	}, [deliveries, reportOliveType]);

	useEffect(() => {
		const timerId = window.setInterval(() => {
			setClockNow(new Date());
		}, 1000);

		return () => {
			window.clearInterval(timerId);
		};
	}, []);

	useEffect(() => {
		const timerId = window.setInterval(() => {
			if (!periodicSaveRef.current) return;
			const saveData = periodicSaveRef.current();
			if (saveData.deliveries.length === 0 && saveData.teslimatlar.length === 0 && saveData.sellers.length === 0) return;
			localStorage.setItem(AUTOSAVE_KEY, JSON.stringify(saveData));
			localStorage.setItem(DRAFT_KEY, JSON.stringify(saveData));
			apiRequest("/state", {
				method: "PUT",
				body: JSON.stringify({ snapshot: saveData }),
			}).catch(() => {});
			setLastAutoSave(saveData.savedAt);
			setSavedSnapshot(saveData);
			setLastPeriodicSaveAt(saveData.savedAt);
		}, 5000);

		return () => {
			window.clearInterval(timerId);
		};
	}, []);

	useEffect(() => {
		let cancelled = false;

		const loadInitialSnapshot = async () => {
			try {
				const stateRes = await apiRequest("/state");
				if (!cancelled && stateRes && stateRes.snapshot) {
					applySnapshotData(stateRes.snapshot);
					return;
				}
			} catch {
				// API ulasilamazsa local fallback kullanilir.
			}

			try {
				const mainSaved = localStorage.getItem(AUTOSAVE_KEY);
				const draftSaved = localStorage.getItem(DRAFT_KEY);
				const source = mainSaved || draftSaved;
				if (!source || cancelled) return;
				const data = JSON.parse(source);
				applySnapshotData(data);
			} catch {}
		};

		loadInitialSnapshot();

		return () => {
			cancelled = true;
		};
	}, []);

	useEffect(() => {
		if (deliveries.length === 0 && teslimatlar.length === 0) return;
		saveAutoSnapshot();
	}, [deliveries, teslimatlar]); // eslint-disable-line

	useEffect(() => {
		const timerId = window.setTimeout(() => {
			try {
				const draftData = buildSnapshotData();
				localStorage.setItem(DRAFT_KEY, JSON.stringify(draftData));
			} catch {}
		}, 800);

		return () => {
			window.clearTimeout(timerId);
		};
	}, [
		deliveries,
		sellers,
		expenses,
		teslimatlar,
		accountRows,
		sellerName,
		sellerPhone,
		sellerOliveType,
		expenseDesc,
		expenseAmount,
		teslimatFirma,
		teslimatKasa,
		teslimatCesit,
		teslimatKg,
		teslimatFiyat,
	]);

	useEffect(() => {
		const persistOnClose = () => {
			try {
				const saveData = buildSnapshotData();
				localStorage.setItem(AUTOSAVE_KEY, JSON.stringify(saveData));
				localStorage.setItem(DRAFT_KEY, JSON.stringify(saveData));
			} catch {}
		};

		window.addEventListener("beforeunload", persistOnClose);
		window.addEventListener("pagehide", persistOnClose);

		return () => {
			window.removeEventListener("beforeunload", persistOnClose);
			window.removeEventListener("pagehide", persistOnClose);
		};
	}, [
		deliveries,
		sellers,
		expenses,
		teslimatlar,
		accountRows,
		sellerName,
		sellerPhone,
		sellerOliveType,
		expenseDesc,
		expenseAmount,
		teslimatFirma,
		teslimatKasa,
		teslimatCesit,
		teslimatKg,
		teslimatFiyat,
	]);

	useEffect(() => {
		if (!showSellerSuggestions) return;

		const handleClickOutside = (event) => {
			if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
				setShowSellerSuggestions(false);
			}
		};

		document.addEventListener("click", handleClickOutside);
		return () => document.removeEventListener("click", handleClickOutside);
	}, [showSellerSuggestions]);

	useEffect(() => {
		let cancelled = false;

		const loadRecordSnapshot = async () => {
			try {
				const snapshot = await apiRequest("/records/snapshot");
				if (cancelled || !snapshot) return;
				if (Array.isArray(snapshot.expenses)) {
					setExpenses((current) =>
						snapshot.expenses.length > 0 || current.length === 0
							? snapshot.expenses.map(toUiExpense)
							: current
					);
				}
				if (Array.isArray(snapshot.teslimatlar)) {
					setTeslimatlar((current) =>
						snapshot.teslimatlar.length > 0 || current.length === 0
							? snapshot.teslimatlar.map(toUiTeslimat)
							: current
					);
				}
			} catch {
				// API yoksa mevcut local davranis bozulmadan devam eder.
			}
		};

		loadRecordSnapshot();

		return () => {
			cancelled = true;
		};
	}, []);

	useEffect(() => {
		if (!isAdmin) return;
		let cancelled = false;

		const loadMembersFromApi = async () => {
			try {
				const apiMembers = await apiRequest("/members");
				if (cancelled || !Array.isArray(apiMembers)) return;
				const normalized = apiMembers.map(toUiMember);
				setMembers(normalized);
				localStorage.setItem("zeytinhesap_members", JSON.stringify(normalized));
			} catch {
				// API'ye ulasilamazsa mevcut localStorage davranisi devam eder.
			}
		};

		loadMembersFromApi();

		return () => {
			cancelled = true;
		};
	}, [isAdmin]);

	useEffect(() => {
		if (adminView !== "payment" || !selectedAdminMemberId) return;
		let cancelled = false;

		const loadPayments = async () => {
			try {
				const apiPayments = await apiRequest(`/payments/member/${selectedAdminMemberId}`);
				if (cancelled || !Array.isArray(apiPayments)) return;
				const normalizedPayments = apiPayments.map(toUiPayment);
				setMembers((current) => {
					const updated = current.map((member) =>
						Number(member.id) === Number(selectedAdminMemberId)
							? { ...member, payments: normalizedPayments }
							: member
					);
					localStorage.setItem("zeytinhesap_members", JSON.stringify(updated));
					return updated;
				});
			} catch {
				// API'ye ulasilamazsa local odeme gecmisi kullanilir.
			}
		};

		loadPayments();

		return () => {
			cancelled = true;
		};
	}, [adminView, selectedAdminMemberId]);

	const updateAccountRow = (rowName, field, value) => {
		setAccountRows((rows) =>
			rows.map((row) => (row.name === rowName ? { ...row, [field]: value } : row))
		);
	};

	const handleResetAccountRows = () => {
		setAccountRows(classNames.map((name) => ({ name, kg: "0", price: "0" })));
		setIsAccountTableLocked(false);
	};

	const handleSaveAccountTable = () => {
		handleAddDelivery();
		setIsAccountTableLocked(true);
	};

	const getDeliveryDateKey = (delivery) => {
		if (delivery.dayKey) {
			return delivery.dayKey;
		}
		if (delivery.createdAt) {
			return formatDateKeyLocal(new Date(delivery.createdAt));
		}
		if (typeof delivery.id === "number") {
			return formatDateKeyLocal(new Date(delivery.id));
		}
		return "";
	};

	const handlePrevDailyReportDate = () => {
		const baseDate = dailyReportDate ? new Date(`${dailyReportDate}T00:00:00`) : new Date();
		baseDate.setDate(baseDate.getDate() - 1);
		setDailyReportDate(formatDateKeyLocal(baseDate));
	};

	const handleTodayDailyReportDate = () => {
		setDailyReportDate(formatDateKeyLocal(new Date()));
	};

	const updateReportRow = (rowName, field, value) => {
		setReportRows((rows) =>
			rows.map((row) => (row.name === rowName ? { ...row, [field]: value } : row))
		);
	};

	const updateOlivePurchaseRow = (rowName, field, value) => {
		setOlivePurchaseRows((rows) =>
			rows.map((row) => (row.name === rowName ? { ...row, [field]: value } : row))
		);
	};

	const handleRemoveTeslimat = async (teslimatId) => {
		try {
			await apiRequest(`/records/teslimatlar/${teslimatId}`, { method: "DELETE" });
		} catch {
			// API silme hatasinda local silme yine devam etsin.
		}
		setTeslimatlar((prev) => prev.filter((item) => Number(item.id) !== Number(teslimatId)));
		setSelectedTeslimatKaydiId((prev) => (prev === String(teslimatId) ? "" : prev));
	};

	const handleKasaDus = async () => {
		if (!selectedTeslimatKaydiId) {
			return;
		}

		const dusulecekAdet = Math.max(1, Math.floor(parseNumber(kasaDusAdedi) || 1));
		const selectedRecord = teslimatlar.find(
			(item) => String(item.id) === String(selectedTeslimatKaydiId)
		);

		if (!selectedRecord) return;

		const kalanKasa = Math.max(0, parseNumber(selectedRecord.kasa) - dusulecekAdet);

		try {
			await apiRequest(`/records/teslimatlar/${selectedTeslimatKaydiId}`, {
				method: "PATCH",
				body: JSON.stringify({ kasa: kalanKasa ? String(kalanKasa) : "" }),
			});
		} catch {
			// API patch hatasi olsa da local isleyis devam eder.
		}

		setTeslimatlar((prev) =>
			prev.map((item) => {
				if (String(item.id) !== selectedTeslimatKaydiId) {
					return item;
				}

				return { ...item, kasa: kalanKasa ? String(kalanKasa) : "" };
			})
		);
	};

	const handleAddExpense = async () => {
		const desc = expenseDesc.trim();
		const amount = parseNumber(expenseAmount);
		if (!desc || !expenseAmount.trim()) return;

		try {
			const created = await apiRequest("/records/expenses", {
				method: "POST",
				body: JSON.stringify({ desc, amount }),
			});
			setExpenses((prev) => [toUiExpense(created), ...prev]);
			setExpenseDesc("");
			setExpenseAmount("");
			return;
		} catch {
			// API yazma basarisizsa local fallback.
		}

		setExpenses((prev) => [{ id: Date.now(), desc, amount }, ...prev]);
		setExpenseDesc("");
		setExpenseAmount("");
	};

	const handleDeleteExpense = async (expenseId) => {
		try {
			await apiRequest(`/records/expenses/${expenseId}`, { method: "DELETE" });
		} catch {
			// API silme hatasinda local silme devam eder.
		}
		setExpenses((prev) => prev.filter((item) => Number(item.id) !== Number(expenseId)));
	};

	const handleAddTeslimat = async () => {
		if (!teslimatFirma.trim()) return;

		const payload = {
			firma: teslimatFirma.trim(),
			kasa: teslimatKasa,
			cesit: teslimatCesit,
			kg: parseNumber(teslimatKg),
			fiyat: parseNumber(teslimatFiyat),
		};

		try {
			const created = await apiRequest("/records/teslimatlar", {
				method: "POST",
				body: JSON.stringify(payload),
			});
			const normalized = toUiTeslimat(created);
			setTeslimatlar((prev) => [normalized, ...prev]);
			setSelectedTeslimatKaydiId(String(normalized.id));
			setTeslimatFirma("");
			setTeslimatKasa("");
			setTeslimatCesit("");
			setTeslimatKg("");
			setTeslimatFiyat("");
			return;
		} catch {
			// API yazma basarisizsa local fallback.
		}

		const yeniTeslimatId = Date.now();
		setTeslimatlar((prev) => [
			{
				id: yeniTeslimatId,
				firma: payload.firma,
				kasa: payload.kasa,
				cesit: payload.cesit,
				kg: payload.kg,
				fiyat: payload.fiyat,
			},
			...prev,
		]);
		setSelectedTeslimatKaydiId(String(yeniTeslimatId));
		setTeslimatFirma("");
		setTeslimatKasa("");
		setTeslimatCesit("");
		setTeslimatKg("");
		setTeslimatFiyat("");
	};

	const handleRestoreAutoSave = () => {
		try {
			const saved = localStorage.getItem(AUTOSAVE_KEY);
			if (!saved) return;
			const data = JSON.parse(saved);
			if (Array.isArray(data.deliveries)) setDeliveries(data.deliveries);
			if (Array.isArray(data.sellers)) setSellers(data.sellers);
			if (Array.isArray(data.expenses)) setExpenses(data.expenses);
			if (Array.isArray(data.teslimatlar)) setTeslimatlar(data.teslimatlar);
			if (Array.isArray(data.accountRows)) setAccountRows(data.accountRows);
		} catch {}
	};

	const saveAutoSnapshot = (overrides = {}) => {
		try {
			const saveData = buildSnapshotData(overrides);
			if (
				saveData.deliveries.length === 0 &&
				saveData.teslimatlar.length === 0 &&
				saveData.sellers.length === 0
			) {
				return;
			}
			localStorage.setItem(AUTOSAVE_KEY, JSON.stringify(saveData));
			localStorage.setItem(DRAFT_KEY, JSON.stringify(saveData));
			apiRequest("/state", {
				method: "PUT",
				body: JSON.stringify({ snapshot: saveData }),
			}).catch(() => {});
			setLastAutoSave(saveData.savedAt);
			setSavedSnapshot(saveData);
		} catch {}
	};

	const handleManualSave = () => {
		saveAutoSnapshot();
	};

	const totalKg = accountRows.reduce((sum, row) => sum + parseNumber(row.kg), 0);
	const totalAmount = accountRows.reduce(
		(sum, row) => sum + parseNumber(row.kg) * parseNumber(row.price),
		0
	);
	const avgPrice = totalKg ? totalAmount / totalKg : 0;
	const oliveTotalKg = olivePurchaseRows.reduce((sum, row) => sum + parseNumber(row.kg), 0);
	const oliveTotalAmount = olivePurchaseRows.reduce(
		(sum, row) => sum + parseNumber(row.kg) * parseNumber(row.price),
		0
	);
	const oliveAvgPrice = oliveTotalKg ? oliveTotalAmount / oliveTotalKg : 0;
	const reportTotalKg = reportRows.reduce((sum, row) => sum + parseNumber(row.kg), 0);
	const reportTotalAmount = reportRows.reduce(
		(sum, row) => sum + parseNumber(row.kg) * parseNumber(row.price),
		0
	);
	const reportAvgPrice = reportTotalKg ? reportTotalAmount / reportTotalKg : 0;
	const clockHour = clockNow.getHours() % 12;
	const clockMinute = clockNow.getMinutes();
	const clockSecond = clockNow.getSeconds();
	const hourRotation = clockHour * 30 + clockMinute * 0.5;
	const minuteRotation = clockMinute * 6 + clockSecond * 0.1;
	const secondRotation = clockSecond * 6;
	const clockDateText = clockNow.toLocaleDateString("tr-TR");
	const clockDayText = clockNow.toLocaleDateString("tr-TR", { weekday: "long" });
	const clockTimeText = clockNow.toLocaleTimeString("tr-TR");
	const formatAutoSaveDateTime = (value) => {
		if (!value) return "-";
		const date = new Date(value);
		if (Number.isNaN(date.getTime())) return "-";
		const dayName = date.toLocaleDateString("tr-TR", { weekday: "long" });
		const dayNameTitle = dayName.charAt(0).toUpperCase() + dayName.slice(1);
		return `${date.toLocaleDateString("tr-TR")} ${dayNameTitle} ${date.toLocaleTimeString("tr-TR", {
			hour: "2-digit",
			minute: "2-digit",
			second: "2-digit",
		})}`;
	};
	const formatPeriodicSaveTime = (value) => {
		if (!value) return null;
		const date = new Date(value);
		if (Number.isNaN(date.getTime())) return null;
		const dayName = date.toLocaleDateString("tr-TR", { weekday: "long" });
		const dayNameTitle = dayName.charAt(0).toUpperCase() + dayName.slice(1);
		return `${dayNameTitle} ${date.toLocaleTimeString("tr-TR", {
			hour: "2-digit",
			minute: "2-digit",
			second: "2-digit",
		})}`;
	};
	const dailyTotalDelivery = deliveries.reduce((sum, item) => sum + parseNumber(item.kg), 0);
	const autoDeliveryName = tradeSellerName;
	const autoDeliveryType = tradeOliveType;
	const autoDeliveryKg = totalKg ? String(totalKg) : "";
	const selectedTeslimatKaydi = teslimatlar.find(
		(item) => String(item.id) === selectedTeslimatKaydiId
	);
	const normalizedTabValue = String(activeTab || "").toLocaleLowerCase("tr-TR");
	const currentTabKey =
		normalizedTabValue === "kayıt" || normalizedTabValue === "kayit"
			? "gider"
			: normalizedTabValue;
	const filteredDailyDeliveries = deliveries.filter((delivery) => {
		if (!dailyReportDate) {
			return true;
		}
		return getDeliveryDateKey(delivery) === dailyReportDate;
	});
	const dailyClassTypeRows = classNames.map((className) => ({
		name: className,
		values: oliveTypes.map((oliveTypeName) =>
			filteredDailyDeliveries
				.filter((delivery) => (delivery.oliveType || "") === oliveTypeName)
				.reduce((sum, delivery) => {
					if (delivery.classBreakdown && Array.isArray(delivery.classBreakdown)) {
						const matchedClass = delivery.classBreakdown.find((item) => item.name === className);
						return sum + parseNumber(matchedClass ? matchedClass.kg : 0);
					}
					return sum;
				}, 0)
				
		),
	}));
	const classDistribution = accountRows.map((row) => {
		const kg = parseNumber(row.kg);
		return {
			name: row.name,
			kg,
			kasa: kg ? (kg / 22).toFixed(1) : "",
		};
	});

	// jsPDF varsayilan fontu Turkce karakter ve ₺ desteklemez
	const pdfSafe = (str) =>
		String(str || "")
			.replace(/₺/g, "TL")
			.replace(/ı/g, "i")
			.replace(/İ/g, "I")
			.replace(/ğ/g, "g")
			.replace(/Ğ/g, "G")
			.replace(/ş/g, "s")
			.replace(/Ş/g, "S")
			.replace(/ç/g, "c")
			.replace(/Ç/g, "C")
			.replace(/ö/g, "o")
			.replace(/Ö/g, "O")
			.replace(/ü/g, "u")
			.replace(/Ü/g, "U");

	const accountTableBody = accountRows.map((row) => {
		const rowKg = parseNumber(row.kg);
		const rowPrice = parseNumber(row.price);
		return [
			row.name,
			row.kg || "",
			row.price ? formatMoney(rowPrice) : "",
			formatMoney(rowKg * rowPrice),
		];
	});

	const createAccountPdfDoc = () => {
		const doc = new jsPDF({ unit: "pt", format: "a4" });
		const recordMeta = getRecordDateTime();
		const sellerInfoText = `${tradeSellerName || "-"} | ${tradeOliveType || "Zeytin cesidi secilmedi"}`;
		doc.setFontSize(14);
		doc.text("Hesap Tablosu", 40, 40);
		doc.setFontSize(10);
		doc.text(
			pdfSafe(`Tarih: ${recordMeta.dateText} | Gun: ${recordMeta.dayText} | Saat: ${recordMeta.timeText}`),
			40,
			54
		);
		doc.text(pdfSafe(`Satici: ${sellerInfoText}`), 40, 66);

		const safeBody = accountTableBody.map((cells) => cells.map(pdfSafe));
		const safeTotalRow = [
			"",
			totalKg ? String(totalKg) : "",
			totalKg ? pdfSafe(`Ort. ${formatMoney(avgPrice)}`) : "",
			pdfSafe(formatMoney(totalAmount)),
		];

		autoTable(doc, {
			startY: 80,
			head: [["Sinif", "Kg", "Fiyat", "Toplam"]],
			body: [...safeBody, safeTotalRow],
			theme: "grid",
			headStyles: { fillColor: [245, 245, 244], textColor: [68, 64, 60] },
			bodyStyles: { textColor: [41, 37, 36] },
			columnStyles: {
				0: { cellWidth: 80 },
				1: { cellWidth: 60, halign: "center" },
				2: { cellWidth: 100, halign: "right" },
				3: { cellWidth: 110, halign: "right" },
			},
		});

		return doc;
	};

	const handleExportAccountPdf = () => {
		const doc = createAccountPdfDoc();
		doc.save("hesap-tablosu.pdf");
	};

	const handlePreviewAccountPdf = () => {
		const doc = createAccountPdfDoc();
		const pdfBlob = doc.output("blob");
		const previewUrl = window.URL.createObjectURL(pdfBlob);
		window.open(previewUrl, "_blank");

		window.setTimeout(() => {
			window.URL.revokeObjectURL(previewUrl);
		}, 60000);
	};

	const handleShareAccountPdf = async () => {
		const doc = createAccountPdfDoc();
		const fileName = "hesap-tablosu.pdf";
		const pdfBlob = doc.output("blob");
		const shareFile = new File([pdfBlob], fileName, { type: "application/pdf" });

		try {
			if (navigator.share) {
				if (!navigator.canShare || navigator.canShare({ files: [shareFile] })) {
					await navigator.share({
						title: "Hesap Tablosu",
						text: "Hesap tablosu PDF dosyasi",
						files: [shareFile],
					});
					return;
				}

				await navigator.share({
					title: "Hesap Tablosu",
					text: "Hesap tablosu PDF dosyasi olusturuldu.",
				});
				return;
			}
		} catch (error) {
			return;
		}

		doc.save(fileName);
		window.open(
			"https://wa.me/?text=Hesap%20tablosu%20PDF%20indirildi.%20WhatsApp%27tan%20dosya%20olarak%20ekleyebilirsiniz.",
			"_blank"
		);
	};

	const handlePrintAccountTable = () => {
		const recordMeta = getRecordDateTime();
		const sellerInfoText = `${tradeSellerName || "-"} | ${tradeOliveType || "Zeytin çeşidi seçilmedi"}`;
		const printableRows = [
			...accountTableBody,
			[
				"",
				totalKg ? String(totalKg) : "",
				totalKg ? `Ort. ${formatMoney(avgPrice)}` : "",
				formatMoney(totalAmount),
			],
		];

		const rowsHtml = printableRows
			.map(
				(row) =>
					`<tr>${row
						.map((cell, index) => `<td style="padding:8px;border:1px solid #e7e5e4;${index === 3 ? "text-align:right;" : ""}">${cell || ""}</td>`)
						.join("")}</tr>`
			)
			.join("");

		const printWindow = window.open("", "_blank", "width=900,height=700");
		if (!printWindow) {
			return;
		}

		printWindow.document.write(`
			<html>
				<head>
					<title>Hesap Tablosu</title>
					<style>
						body { font-family: Arial, sans-serif; padding: 24px; }
						h2 { margin: 0 0 16px; }
						.meta { margin: 0 0 12px; color: #44403c; font-size: 12px; }
						.meta-strong { margin: 0 0 10px; color: #1c1917; font-size: 12px; font-weight: 700; }
						table { border-collapse: collapse; width: 100%; font-size: 12px; }
						th { background: #f5f5f4; border: 1px solid #e7e5e4; padding: 8px; text-align: center; }
					</style>
				</head>
				<body>
					<h2>Hesap Tablosu</h2>
					<div class="meta-strong">Satıcı: ${sellerInfoText}</div>
					<div class="meta">Tarih: ${recordMeta.dateText} | Gün: ${recordMeta.dayText} | Saat: ${recordMeta.timeText}</div>
					<table>
						<thead>
							<tr>
								<th>Sınıf</th>
								<th>Kg</th>
								<th>Fiyat</th>
								<th>Toplam</th>
							</tr>
						</thead>
						<tbody>${rowsHtml}</tbody>
					</table>
				</body>
			</html>
		`);
		printWindow.document.close();
		printWindow.focus();

		// Bazi tarayicilarda pencereyi hemen kapatmak yazdirma diyalogunu engeller.
		printWindow.onafterprint = () => {
			printWindow.close();
		};

		setTimeout(() => {
			printWindow.print();
		}, 150);
	};

	const handleAdminLogin = () => {
		if (isAdmin) {
			setIsAdmin(false);
			return;
		}
		const password = window.prompt("Admin şifresi girin:");
		if (password === "0-0") {
			setIsAdmin(true);
		} else if (password !== null) {
			alert("Yanlış şifre!");
		}
	};

	const saveMembers = (updated) => {
		setMembers(updated);
		localStorage.setItem("zeytinhesap_members", JSON.stringify(updated));
	};

	const handleAddMember = async () => {
		const name = memberForm.name.trim();
		const phone = memberForm.phone.trim();
		if (!name || !phone) { alert("Ad Soyad ve Telefon zorunlu!"); return; }

		try {
			const created = await apiRequest("/members", {
				method: "POST",
				body: JSON.stringify({
					name,
					phone,
					email: memberForm.email.trim(),
				}),
			});
			const normalizedCreated = toUiMember(created);
			saveMembers([
				normalizedCreated,
				...members.filter((m) => Number(m.id) !== Number(normalizedCreated.id)),
			]);
			setMemberForm({ name: "", phone: "", email: "" });
			setAdminView("list");
			return;
		} catch {
			// API'ye ulasilamazsa local kayitla devam edilir.
		}

		const newMember = {
			id: Date.now(),
			name,
			phone,
			email: memberForm.email.trim(),
			registeredAt: new Date().toISOString(),
			expiresAt: null,
			payments: [],
		};
		saveMembers([newMember, ...members]);
		setMemberForm({ name: "", phone: "", email: "" });
		setAdminView("list");
	};

	const handleAddPayment = async () => {
		const amount = parseFloat(paymentAmount);
		const days = parseInt(paymentDays, 10);
		if (!selectedAdminMemberId) return;
		if (isNaN(amount) || amount <= 0) { alert("Geçerli bir ödeme tutarı girin!"); return; }
		if (isNaN(days) || days <= 0) { alert("Geçerli bir süre girin!"); return; }

		try {
			const paymentResult = await apiRequest(`/payments/member/${selectedAdminMemberId}`, {
				method: "POST",
				body: JSON.stringify({
					amount,
					duration_days: days,
				}),
			});
			const apiPayments = await apiRequest(`/payments/member/${selectedAdminMemberId}`);
			const normalizedPayments = Array.isArray(apiPayments) ? apiPayments.map(toUiPayment) : [];
			const updatedFromApi = members.map((member) =>
				Number(member.id) === Number(selectedAdminMemberId)
					? {
						...member,
						expiresAt: paymentResult?.new_expires_at || member.expiresAt,
						payments: normalizedPayments,
					}
					: member
			);
			saveMembers(updatedFromApi);
			setPaymentAmount("");
			setPaymentDays("");
			setAdminView("list");
			return;
		} catch {
			// API'ye ulasilamazsa local odeme akisi devam eder.
		}

		const updated = members.map((m) => {
			if (m.id !== selectedAdminMemberId) return m;
			const base = m.expiresAt && new Date(m.expiresAt) > new Date()
				? new Date(m.expiresAt)
				: new Date();
			base.setDate(base.getDate() + days);
			const payment = { id: Date.now(), amount, durationDays: days, paidAt: new Date().toISOString() };
			return { ...m, expiresAt: base.toISOString(), payments: [payment, ...(m.payments || [])] };
		});
		saveMembers(updated);
		setPaymentAmount("");
		setPaymentDays("");
		setAdminView("list");
	};

	const handleDeleteMember = async (memberId) => {
		if (!window.confirm("Bu üyeyi silmek istediğinize emin misiniz?")) return;
		try {
			await apiRequest(`/members/${memberId}`, { method: "DELETE" });
		} catch {
			// API'ye ulasilamazsa local silme devam eder.
		}
		saveMembers(members.filter((m) => m.id !== memberId));
	};

	const getMemberStatus = (member) => {
		if (!member.expiresAt) return { label: "Süre Yok", color: "text-stone-400" };
		const now = new Date();
		const exp = new Date(member.expiresAt);
		const diffDays = Math.ceil((exp - now) / (1000 * 60 * 60 * 24));
		if (diffDays < 0) return { label: "Süresi Doldu", color: "text-red-600" };
		if (diffDays <= 7) return { label: `${diffDays} gün kaldı`, color: "text-orange-500" };
		return { label: `${diffDays} gün kaldı`, color: "text-green-600" };
	};

	return (
		<div className="h-screen bg-stone-100 flex flex-col md:flex-row overflow-hidden">
			<div className="w-full md:w-[320px] bg-gradient-to-br from-green-800 via-green-700 to-lime-600 text-white p-4 md:p-8 shadow-2xl relative shrink-0 overflow-hidden md:min-h-screen md:rounded-r-3xl">
<div className="absolute -top-16 -right-16 w-44 h-44 bg-green-300 rounded-full blur-3xl opacity-25 hidden md:block" />
				<div className="absolute -bottom-16 -left-16 w-44 h-44 bg-lime-300 rounded-full blur-3xl opacity-25 hidden md:block" />

					<div className="relative">
						<div className="text-xs uppercase tracking-widest bg-white/20 inline-block px-3 py-1 rounded-full hidden md:inline-block">
							Panel Menu
						</div>
						<div className="md:hidden text-sm font-black tracking-wide">☰ Panel Menü</div>

<div className="mt-3 md:mt-6 flex gap-3 overflow-x-auto pb-2 -mx-3 px-3 snap-x md:flex-col md:gap-2 md:overflow-x-visible md:pb-0 md:mx-0 md:px-0 md:space-y-0">
	{tabs.map((tab) => (
		<button
			key={tab.key}
			type="button"
			onClick={() => setActiveTab(tab.key)}
			className={`min-w-[220px] max-w-[90vw] flex-shrink-0 snap-center md:w-full text-left rounded-2xl px-4 py-3 text-base font-semibold transition shadow border border-white/20 ${
				currentTabKey === tab.key
					? "bg-white/25 border-white/30"
					: "bg-white/10 border-white/15 hover:bg-white/15"
			}`}
		>
			{tab.label}
		</button>
	))}
						{isAdmin && (
							<button
								type="button"
								onClick={() => setActiveTab("admin")}
								className={`shrink-0 md:w-full text-left rounded-xl px-3 py-2 md:px-4 md:py-3 text-sm font-semibold transition ${
									currentTabKey === "admin"
										? "bg-yellow-400/40 border border-yellow-300/60"
										: "bg-yellow-500/20 border border-yellow-400/30 hover:bg-yellow-500/30"
								}`}
							>
								Üye Yönetimi
							</button>
						)}
						<button
							type="button"
							onClick={() => { localStorage.removeItem("zeytinhesap_auth"); window.location.href = "/"; }}
							className="shrink-0 md:w-full text-left rounded-xl px-3 py-2 md:px-4 md:py-3 text-sm font-semibold transition bg-red-600/80 border border-red-400/50 hover:bg-red-700/90 text-white uppercase tracking-wide"
							>
								🚪 Çıkış
							</button>
						</div>

						<div className="mt-4 pt-4 border-t border-white/20" />
					</div>
			</div>

			<div className="flex-1 flex flex-col h-full overflow-hidden">
				<div className="flex-1 overflow-auto bg-white border-l border-stone-200 p-4 md:p-6">
					{currentTabKey === "hesap" && (
						<div className="flex flex-wrap items-start gap-4">
							<div className="w-[220px]">
								<div className="h-[350px] bg-white border border-stone-200 rounded-2xl shadow-sm overflow-hidden flex flex-col">
									<div className="border-b border-stone-200 bg-stone-50 px-3 py-2.5">
										<h1 className="text-base font-black text-stone-800">Hesap Satıcı Kaydı</h1>
									</div>

									<div className="flex-1 p-2.5 space-y-2 overflow-hidden">
										<div className="space-y-1.5 w-[190px]">
											<div>
												<select
													className="w-full p-1 border rounded text-[11px] bg-white"
													value={sellerOliveType}
													onChange={(e) => handleSellerOliveTypeChange(e.target.value)}
												>
													<option value="">Zeytin Çeşidi Seç</option>
													{oliveTypes.map((type) => (
														<option key={type} value={type}>
															{type}
														</option>
													))}
												</select>
											</div>

											<div className="relative" ref={dropdownRef}>
												<div className="text-[11px] font-semibold text-stone-700 mb-1">Ad Soyad</div>
												<input
													type="text"
													value={sellerName}
													onChange={(e) => {
									setSellerName(normalizeTurkishUpperText(e.target.value));
									setShowSellerSuggestions(true);
								}}
													className="w-full rounded-md border border-stone-300 px-2 py-1 text-[11px] outline-none focus:ring-2 focus:ring-green-600"
												/>
												{showSellerSuggestions && similarSellerSuggestions.length > 0 && (
													<div className="absolute left-0 right-0 top-full mt-1 z-20 rounded-md border border-stone-200 bg-stone-50 max-h-[88px] overflow-y-auto shadow-md">
														{similarSellerSuggestions.map((seller) => (
															<button
																type="button"
																key={`suggestion-${seller.id}`}
																onClick={() => handleSelectSellerSuggestion(seller)}
																className="w-full text-left px-2 py-1 border-b border-stone-200 last:border-b-0 hover:bg-stone-100 transition"
															>
																<div className="text-[10px] font-semibold text-stone-700 truncate">{normalizeTurkishUpperText(seller.name)}</div>
																<div className="text-[9px] text-stone-500">{seller.phone}</div>
															</button>
														))}
													</div>
												)}
											</div>

											<div>
												<div className="text-[11px] font-semibold text-stone-700 mb-1">Telefon Numarası</div>
												<input
													type="text"
													value={sellerPhone}
													onChange={(e) => setSellerPhone(e.target.value)}
													className="w-full rounded-md border border-stone-300 px-2 py-1 text-[11px] outline-none focus:ring-2 focus:ring-green-600"
												/>
											</div>

											<div>
												<button
													type="button"
													onClick={handleAddSeller}
													className="bg-green-700 text-white px-2.5 py-1 rounded-md text-[11px] font-bold hover:bg-green-800 transition"
												>
													Satıcı Ekle
												</button>
												{sellerAddInfo && (
													<div className="mt-1 text-[10px] text-green-700 font-semibold leading-tight">{sellerAddInfo}</div>
												)}
											</div>
										</div>

										<div>
											<div className="text-[11px] font-semibold text-stone-700 mb-1">
												Eski Satıcı Kayıtlarını Aç
											</div>
											<select
												className="w-full max-w-[190px] p-1 border rounded text-[11px] bg-white"
												value={selectedSellerId}
												onChange={(e) => setSelectedSellerId(e.target.value)}
											>
												<option value="">Satıcı Seç</option>
												{sellers.map((seller) => (
													<option key={seller.id} value={String(seller.id)}>
														{seller.name}
													</option>
												))}
											</select>

											{selectedSeller && (
												<button
													type="button"
													onClick={() => setIsHistoryOpen(true)}
													className="mt-1.5 w-full max-w-[190px] rounded-md border border-green-200 bg-green-50 px-2 py-1 text-left text-[11px] font-bold text-green-700 hover:bg-green-100 transition"
												>
													{selectedSeller.name} gecmisini ac
												</button>
											)}

											<div className="pt-3 border-t border-stone-200 text-xs font-bold text-stone-700">
												Toplam Satıcı Sayısı: {sellers.length}
											</div>
										</div>
									</div>
								</div>
							</div>

							<div className="w-[350px] space-y-3">
								<div className="h-[350px] bg-white border border-emerald-300 rounded-2xl shadow-sm overflow-hidden flex flex-col">
									<div className="border-b border-emerald-300 bg-stone-50 px-3 py-2.5 flex items-center justify-between gap-2">
										<div className="flex items-center gap-2">
											<h1 className="text-base font-black text-stone-800">Hesap Tablosu</h1>
											<button
												type="button"
												onClick={handleSaveAccountTable}
												className="bg-green-700 text-white px-2.5 py-1 rounded-md text-[11px] font-bold hover:bg-green-800 transition"
											>
												Kaydet
											</button>
											<button
												type="button"
												onClick={handleResetAccountRows}
												className="bg-stone-600 text-white px-2.5 py-1 rounded-md text-[11px] font-bold hover:bg-stone-700 transition"
											>
												Sıfırla
											</button>
										</div>
										{(tradeSellerName || tradeOliveType) && (
											<div className="text-[11px] text-stone-600 bg-white border border-emerald-300 rounded-lg px-2 py-1 min-w-[120px] text-center">
												<div className="font-semibold text-stone-800 leading-tight">{tradeSellerName || "-"}</div>
												<div className="text-[10px] text-stone-500 leading-tight mt-0.5">{tradeOliveType || "Zeytin çeşidi seçilmedi"}</div>
											</div>
										)}
									</div>

									<div className="flex-1 p-3">
										<div className="h-full w-full rounded-md border border-emerald-300 overflow-hidden">
											<table className="w-full table-fixed text-[10px]">
												<colgroup>
													<col style={{ width: "40%" }} />
													<col style={{ width: "20%" }} />
													<col style={{ width: "20%" }} />
													<col style={{ width: "20%" }} />
												</colgroup>
												<thead className="bg-stone-50 text-stone-600">
													<tr>
														<th className="text-center px-1 py-1">Sınıf</th>
														<th className="text-center px-1 py-1">Kg</th>
														<th className="text-center px-1 py-1">Fiyat</th>
														<th className="text-center px-1 py-1">Toplam</th>
													</tr>
												</thead>
												<tbody className="text-stone-700">
													{accountRows.map((row) => (
														<tr key={row.name} className="border-t border-stone-100">
															<td className="px-1 py-1 font-semibold truncate">{row.name}</td>
															<td className="px-1 py-1 text-center">
																<input
																	type="text"
																	value={row.kg}
																	onChange={(e) => updateAccountRow(row.name, "kg", e.target.value)}
																	className="w-full border border-emerald-300 rounded px-1 py-0.5 text-[10px] text-center"
																/>
															</td>
															<td className="px-1 py-1 text-center">
																<input
																	type="text"
																	value={row.price}
																	disabled={isAccountTableLocked}
																	tabIndex={isAccountTableLocked ? -1 : 0}
																	onChange={(e) => updateAccountRow(row.name, "price", e.target.value)}
																	className={`w-full border border-emerald-300 rounded px-1 py-0.5 text-[10px] text-center ${
																		isAccountTableLocked ? "bg-stone-100 text-stone-500 cursor-not-allowed" : ""
																	}`}
																/>
															</td>
															<td className="px-1 py-1 text-center font-semibold text-[10px] truncate">
																{formatMoney(parseNumber(row.kg) * parseNumber(row.price))}
															</td>
														</tr>
													))}
													<tr className="border-t border-emerald-300 bg-stone-50">
														<td className="px-1 py-1 align-middle font-bold text-stone-700 truncate">Toplam</td>
														<td className="px-1 py-1 align-middle text-center">
															<span className="text-[10px] font-semibold">
																{totalKg || ""}
															</span>
														</td>
														<td className="px-1 py-1 align-middle text-center">
															<span className="text-[10px] font-semibold truncate">
																{totalKg ? `Ort. ${formatMoney(avgPrice)}` : ""}
															</span>
														</td>
														<td className="px-1 py-1 align-middle text-center">
															<span className="text-[10px] font-semibold">
																{formatMoney(totalAmount)}
															</span>
														</td>
													</tr>
												</tbody>
											</table>
										</div>
									</div>
								</div>

							</div>

							<div className="w-[220px]">
								<div className="h-[350px] bg-white border border-stone-200 rounded-2xl shadow-sm overflow-hidden flex flex-col">
									<div className="border-b border-stone-200 bg-stone-50 px-3 py-2.5">
										<h1 className="text-base font-black text-stone-800">Teslim Yönetimi</h1>
									</div>

									<div className="flex-1 p-2.5 space-y-2 overflow-hidden">
										<div className="space-y-1.5 w-[190px]">
											<div>
												<select
													value={autoDeliveryType}
													disabled
													className="w-full p-1 border rounded text-[11px] bg-stone-50 text-stone-700 cursor-not-allowed"
												>
													<option value="">Zeytin Çeşidi Seç</option>
													{oliveTypes.map((type) => (
														<option key={`auto-${type}`} value={type}>
															{type}
														</option>
													))}
												</select>
											</div>

											<div>
												<div className="text-[11px] font-semibold text-stone-700 mb-1">Ad Soyad</div>
												<input
													type="text"
													value={autoDeliveryName}
													readOnly
													className="w-full rounded-md border border-stone-300 px-2 py-1 text-[11px] bg-stone-50 text-stone-700"
												/>
											</div>

											<div>
												<div className="text-[11px] font-semibold text-stone-700 mb-1">KG</div>
												<input
													type="text"
													value={autoDeliveryKg}
													readOnly
													className="w-full rounded-md border border-stone-300 px-2 py-1 text-[11px] bg-stone-50 text-stone-700"
												/>
											</div>

											<div>
												<button
													type="button"
													onClick={handleAddDeliveryClick}
													className="bg-green-700 text-white px-2.5 py-1 rounded-md text-[11px] font-bold hover:bg-green-800 transition"
												>
													Teslim Ekle
												</button>
												{deliveryAddInfo && (
													<div className="mt-1 text-[10px] text-green-700 font-semibold">{deliveryAddInfo}</div>
												)}
											</div>
										</div>

										<div className="pt-2 border-t border-stone-200 text-[11px] font-bold text-stone-700">
											Günlük Toplam Teslim: {dailyTotalDelivery || 0} kg
										</div>

										<div>
											<div className="text-[11px] font-semibold text-stone-700 mb-1">Teslim Listesi</div>
											<select
												className="w-full max-w-[190px] p-1 border rounded text-[11px] bg-white"
												value={selectedDeliveryListId}
												onChange={(e) => setSelectedDeliveryListId(e.target.value)}
											>
												<option value="">Teslim Seç</option>
												{deliveries.map((item) => (
													<option key={item.id} value={String(item.id)}>
														{item.name}
													</option>
												))}
											</select>
										</div>
									</div>
								</div>
							</div>

							<div className="w-[220px]">
								<div className="h-[350px] bg-white border border-stone-200 rounded-2xl shadow-sm overflow-hidden flex flex-col">
									<div className="border-b border-stone-200 bg-stone-50 px-3 py-2.5">
										<h2 className="text-base font-black text-stone-800">Kasa Dagılım</h2>
									</div>
									<div className="p-2.5">
										<div className="flex items-center gap-1.5">
											<button
												type="button"
												onClick={handleExportAccountPdf}
												className="rounded-md bg-green-700 text-white px-2 py-1 text-[10px] font-bold hover:bg-green-800 transition"
											>
												PDF
											</button>
											<button
												type="button"
												onClick={handlePreviewAccountPdf}
												className="rounded-md border border-stone-300 bg-white text-stone-700 px-2 py-1 text-[10px] font-bold hover:bg-stone-50 transition"
											>
												Aç
											</button>
											<button
												type="button"
												onClick={handleShareAccountPdf}
												className="h-6 w-6 rounded-md border border-stone-300 bg-white text-stone-700 flex items-center justify-center hover:bg-stone-50 transition"
												title="PDF Paylas"
												aria-label="PDF Paylas"
											>
												<svg viewBox="0 0 24 24" className="w-3.5 h-3.5" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
													<circle cx="18" cy="5" r="2" />
													<circle cx="6" cy="12" r="2" />
													<circle cx="18" cy="19" r="2" />
													<path d="M8 12l8-6" />
													<path d="M8 12l8 7" />
												</svg>
											</button>
											<button
												type="button"
												onClick={handlePrintAccountTable}
												className="rounded-md border border-stone-300 bg-white text-stone-700 px-2 py-1 text-[10px] font-bold hover:bg-stone-50 transition"
											>
												Yazdır
											</button>
										</div>
									</div>
									<div className="flex-1 p-2 overflow-y-auto">
										<div className="space-y-1">
											{classDistribution.map((item) => (
												<div key={item.name} className="grid grid-cols-3 items-center rounded border border-stone-200 bg-stone-50 px-2 py-1 text-[10px]">
													<div className="font-semibold text-stone-700 text-center">{item.name}</div>
													<div className="text-stone-600 text-center">{item.kg ? `${item.kg} kg` : ""}</div>
													<div className="text-green-700 font-semibold text-center">{item.kasa ? `${item.kasa} kasa` : ""}</div>
												</div>
											))}
											{totalKg > 0 && (
												<div className="grid grid-cols-3 items-center rounded border border-green-400 bg-green-50 px-2 py-1 text-[10px] mt-1">
													<div className="font-black text-stone-800 text-center">Toplam</div>
													<div className="font-black text-stone-800 text-center">{totalKg} kg</div>
													<div className="font-black text-green-700 text-center">{(totalKg / 22).toFixed(1)} kasa</div>
												</div>
											)}
										</div>
									</div>
								</div>
							</div>

							{/* Giderler Kartı */}
							<div className="w-[220px]">
								<div className="min-h-[350px] bg-white border border-stone-200 rounded-2xl shadow-sm flex flex-col">
									<div className="border-b border-stone-200 bg-stone-50 px-3 py-2 flex items-center justify-between">
										<h2 className="text-base font-black text-stone-800">Giderler</h2>
										<div className="h-6 w-6 rounded-full border border-emerald-300 bg-white text-emerald-700 flex items-center justify-center" title="Saat">
											<svg viewBox="0 0 24 24" className="w-3.5 h-3.5" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
												<circle cx="12" cy="12" r="9" />
												<path d="M12 7v5l3 2" />
											</svg>
										</div>
									</div>
									<div className="p-2 space-y-2">

										{/* Gider Ekle */}
										<div className="space-y-1">
											<div className="text-[9px] font-bold text-stone-500 uppercase tracking-wide">Gider Ekle</div>
											<input
												type="text"
												placeholder="Açıklama"
												value={expenseDesc}
												onChange={(e) => setExpenseDesc(normalizeTurkishUpperText(e.target.value))}
												className="w-full rounded border border-stone-300 px-1.5 py-0.5 text-[10px] focus:outline-none focus:ring-1 focus:ring-green-600"
											/>
											<input
												type="text"
												placeholder="Tutar (₺)"
												value={expenseAmount}
												onChange={(e) => setExpenseAmount(e.target.value)}
												className="w-full rounded border border-stone-300 px-1.5 py-0.5 text-[10px] focus:outline-none focus:ring-1 focus:ring-green-600"
											/>
											<button
												type="button"
												onClick={handleAddExpense}
												className="w-full rounded bg-green-700 text-white px-1.5 py-0.5 text-[10px] font-bold hover:bg-green-800 transition"
											>
												Gider Ekle
											</button>
										</div>

										<div className="border-t border-stone-200" />

										{/* Teslimat Ekle */}
										<div className="space-y-1">
											<div className="text-[9px] font-bold text-stone-500 uppercase tracking-wide">Teslimat Ekle</div>
											<input
												type="text"
												placeholder="Firma Adı"
												value={teslimatFirma}
												onChange={(e) => setTeslimatFirma(normalizeTurkishUpperText(e.target.value))}
												className="w-full rounded border border-stone-300 px-1.5 py-0.5 text-[10px] focus:outline-none focus:ring-1 focus:ring-green-600"
											/>
											<input
												type="text"
												placeholder="Kasa Adeti"
												value={teslimatKasa}
												onChange={(e) => setTeslimatKasa(e.target.value)}
												className="w-full rounded border border-stone-300 px-1.5 py-0.5 text-[10px] focus:outline-none focus:ring-1 focus:ring-green-600"
											/>
											<select
												value={teslimatCesit}
												onChange={(e) => setTeslimatCesit(e.target.value)}
												className="w-full rounded border border-stone-300 px-1.5 py-0.5 text-[10px] focus:outline-none focus:ring-1 focus:ring-green-600 bg-white"
											>
												<option value="">Zeytin Çeşidi Seç</option>
												{oliveTypes.map((t) => <option key={t} value={t}>{t}</option>)}
											</select>
											<div className="flex gap-1">
												<input
													type="text"
													placeholder="KG"
													value={teslimatKg}
													onChange={(e) => setTeslimatKg(e.target.value)}
													className="w-1/2 rounded border border-stone-300 px-1.5 py-0.5 text-[10px] focus:outline-none focus:ring-1 focus:ring-green-600"
												/>
												<input
													type="text"
													placeholder="Fiyat (₺)"
													value={teslimatFiyat}
													onChange={(e) => setTeslimatFiyat(e.target.value)}
													className="w-1/2 rounded border border-stone-300 px-1.5 py-0.5 text-[10px] focus:outline-none focus:ring-1 focus:ring-green-600"
												/>
											</div>
											<button
												type="button"
												onClick={handleAddTeslimat}
												className="w-full rounded bg-green-700 text-white px-1.5 py-0.5 text-[10px] font-bold hover:bg-green-800 transition"
											>
												Kaydet
											</button>
										</div>

										{/* Kayıtlı Giderler */}
										{expenses.length > 0 && (
											<div className="border-t border-stone-200 pt-1 space-y-1">
												<div className="text-[9px] font-bold text-stone-500 uppercase tracking-wide">Gider Listesi</div>
												{expenses.map((item) => (
													<div key={item.id} className="flex items-center justify-between rounded border border-stone-200 bg-stone-50 px-1.5 py-0.5 text-[10px] gap-1">
														<div className="font-semibold text-stone-700 flex-1 truncate">{item.desc}</div>
														<div className="text-red-600 font-semibold whitespace-nowrap">{formatMoney(item.amount)}</div>
														<button type="button" onClick={() => handleDeleteExpense(item.id)} className="text-stone-400 hover:text-red-500 ml-1 font-bold text-[11px] leading-none">×</button>
													</div>
												))}
												<div className="flex items-center justify-between rounded border border-red-400 bg-red-50 px-1.5 py-0.5 text-[10px]">
													<div className="font-black text-stone-800">Toplam</div>
													<div className="font-black text-red-600">{formatMoney(expenses.reduce((s, e) => s + e.amount, 0))}</div>
												</div>
											</div>
										)}

										{/* Kayıtlı Teslimatlar */}
										{teslimatlar.length > 0 && (
											<div className="border-t border-stone-200 pt-1 space-y-1">
												<div className="text-[9px] font-bold text-stone-500 uppercase tracking-wide">Teslimat Listesi</div>
												{teslimatlar.map((t) => (
													<div key={t.id} className="rounded border border-stone-200 bg-stone-50 px-1.5 py-0.5 text-[10px]">
														<div className="flex items-center justify-between">
															<span className="font-semibold text-stone-700 truncate flex-1">{t.firma}</span>
															<button type="button" onClick={() => handleRemoveTeslimat(t.id)} className="text-stone-400 hover:text-red-500 font-bold text-[11px] leading-none ml-1">×</button>
														</div>
														<div className="text-stone-500">{t.cesit}{t.kasa ? ` · ${t.kasa} kasa` : ""}{t.kg ? ` · ${t.kg} kg` : ""}{t.fiyat ? ` · ${formatMoney(t.fiyat)}` : ""}</div>
													</div>
												))}
											</div>
										)}

											<div className="border-t border-stone-200 pt-1 space-y-1">
												<div className="flex items-center gap-1">
													<select
														value={selectedTeslimatKaydiId}
														onChange={(e) => setSelectedTeslimatKaydiId(e.target.value)}
														className="flex-1 rounded border border-stone-300 px-1.5 py-0.5 text-[10px] focus:outline-none focus:ring-1 focus:ring-green-600 bg-white"
													>
														<option value="">Firma Seç</option>
														{teslimatlar.map((item) => (
															<option key={item.id} value={String(item.id)}>
																{item.firma}
															</option>
														))}
													</select>
													<input
														type="text"
														value={kasaDusAdedi}
														onChange={(e) => setKasaDusAdedi(e.target.value)}
														placeholder="Kasa"
														className="w-12 rounded border border-stone-300 px-1.5 py-0.5 text-[10px] text-center focus:outline-none focus:ring-1 focus:ring-green-600"
													/>
													<button
														type="button"
														onClick={handleKasaDus}
														disabled={!selectedTeslimatKaydiId}
														className="rounded border border-stone-300 bg-white px-2 py-0.5 text-[10px] font-bold text-stone-700 hover:bg-stone-50 transition disabled:opacity-50 disabled:cursor-not-allowed"
													>
														Kasa Düş
													</button>
												</div>
												{selectedTeslimatKaydi && (
													<div className="text-[9px] text-stone-500 leading-tight">
														{`${selectedTeslimatKaydi.firma} firmasının kalan kasası: ${selectedTeslimatKaydi.kasa || 0}`}
													</div>
												)}
											</div>

									</div>
								</div>
							</div>

							<div className="w-[220px]">
								<div className="h-[350px] bg-white border border-stone-200 rounded-2xl shadow-sm overflow-hidden flex flex-col">
									<div className="border-b border-stone-200 bg-stone-50 px-3 py-2">
										<h2 className="text-base font-black text-stone-800">Saat</h2>
									</div>
									<div className="flex-1 p-3 flex flex-col items-center justify-between">
										<div className="relative w-36 h-36 rounded-full border-4 border-stone-300 bg-gradient-to-br from-white to-stone-100 shadow-inner">
											<div className="absolute inset-2 rounded-full border border-stone-300" />
											<div className="absolute top-1/2 left-1/2 w-1 h-10 bg-stone-800 rounded origin-bottom -translate-x-1/2 -translate-y-full"
												style={{ transform: `translate(-50%, -100%) rotate(${hourRotation}deg)` }}
											/>
											<div className="absolute top-1/2 left-1/2 w-0.5 h-14 bg-stone-700 rounded origin-bottom -translate-x-1/2 -translate-y-full"
												style={{ transform: `translate(-50%, -100%) rotate(${minuteRotation}deg)` }}
											/>
											<div className="absolute top-1/2 left-1/2 w-0.5 h-16 bg-red-500 rounded origin-bottom -translate-x-1/2 -translate-y-full"
												style={{ transform: `translate(-50%, -100%) rotate(${secondRotation}deg)` }}
											/>
											<div className="absolute top-1/2 left-1/2 w-2.5 h-2.5 bg-stone-800 rounded-full -translate-x-1/2 -translate-y-1/2" />
										</div>

										<div className="w-full space-y-1 text-center">
											<div className="rounded border border-stone-300 bg-stone-50 px-2 py-1 text-[10px]">
												<span className="font-bold text-stone-700">Tarih:</span> {clockDateText}
											</div>
											<div className="rounded border border-stone-300 bg-stone-50 px-2 py-1 text-[10px] capitalize">
												<span className="font-bold text-stone-700">Gün:</span> {clockDayText}
											</div>
											<div className="rounded border border-emerald-300 bg-emerald-50 px-2 py-1 text-[11px] font-bold text-emerald-700">
												Saat: {clockTimeText}
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					)}

					{currentTabKey === "rapor" && (
						<div className="flex flex-wrap items-start gap-4">
							<div className="w-[520px]">
								<div className="h-[350px] bg-white border border-emerald-300 rounded-2xl shadow-sm overflow-hidden flex flex-col">
									<div className="border-b border-emerald-300 bg-stone-50 px-3 py-2.5 flex items-center justify-between gap-2">
										<h1 className="text-base font-black text-stone-800">Hesap Tablosu</h1>
										<select
											value={reportOliveType}
											onChange={(e) => setReportOliveType(e.target.value)}
											className="w-[130px] rounded border border-stone-300 bg-white px-1.5 py-0.5 text-[10px] focus:outline-none focus:ring-1 focus:ring-green-600"
										>
											<option value="">Zeytin Çeşidi Seç</option>
											{oliveTypes.map((type) => (
												<option key={`report-${type}`} value={type}>
													{type}
												</option>
											))}
										</select>
									</div>

									<div className="flex-1 p-3">
										<div className="h-full w-full rounded-md border border-emerald-300 overflow-hidden bg-gradient-to-b from-emerald-50/40 to-white">
											<table className="w-full table-fixed text-[11px] border-separate border-spacing-y-1 px-1">
												<thead className="bg-stone-50 text-stone-600">
													<tr>
														<th className="w-[120px] text-center px-2 py-1.5">Çeşit</th>
														<th className="w-[72px] text-center px-2 py-1.5">Sınıf</th>
														<th className="w-[88px] text-center px-2 py-1.5">
															<span className="inline-block min-w-[56px] border border-emerald-300 rounded bg-white px-1 py-0.5">Kg</span>
														</th>
														<th className="w-[98px] text-center px-2 py-1.5">
															<span className="inline-block min-w-[56px] border border-emerald-300 rounded bg-white px-1 py-0.5">Fiyat</span>
														</th>
														<th className="w-[102px] text-center px-2 py-1.5">Toplam</th>
													</tr>
												</thead>
												<tbody className="text-stone-700">
													{reportRows.map((row) => (
														<tr key={row.name}>
															<td className="px-2 py-1.5 text-center font-semibold bg-emerald-50/80 border border-emerald-200 rounded-l-md">{reportOliveType || ""}</td>
															<td className="px-2 py-1.5 text-center font-semibold bg-emerald-50/80 border-y border-emerald-200">{row.name}</td>
															<td className="px-2 py-1.5 text-center bg-emerald-50/80 border-y border-emerald-200">
																<input
																	type="text"
																	value={row.kg}
																	readOnly
																	className="w-[64px] border border-emerald-300 rounded px-1.5 py-0.5 text-[11px] text-center bg-stone-50 text-stone-700"
																/>
															</td>
															<td className="px-2 py-1.5 text-center bg-emerald-50/80 border-y border-emerald-200">
																<input
																	type="text"
																	value={row.price}
																	onChange={(e) => updateReportRow(row.name, "price", e.target.value)}
																	className="w-[64px] border border-emerald-300 rounded px-1.5 py-0.5 text-[11px] text-center"
																/>
															</td>
															<td className="px-2 py-1.5 text-center font-semibold bg-emerald-50/80 border border-emerald-200 rounded-r-md">
																<span className="inline-flex min-w-[84px] justify-center">
																	{formatMoney(parseNumber(row.kg) * parseNumber(row.price))}
																</span>
															</td>
														</tr>
													))}
													<tr>
														<td className="px-2 py-1.5 font-black text-stone-700 bg-stone-100 border border-emerald-300 rounded-l-md">Toplam</td>
														<td className="px-2 py-1.5 bg-stone-100 border-y border-emerald-300"></td>
														<td className="px-2 py-1.5 text-center bg-stone-100 border-y border-emerald-300">
															<span className="inline-flex min-w-[64px] justify-center border border-emerald-300 rounded bg-white px-1.5 py-0.5 font-semibold whitespace-nowrap">
																{reportTotalKg || ""}
															</span>
														</td>
														<td className="px-2 py-1.5 text-center bg-stone-100 border-y border-emerald-300">
															<span className="inline-flex min-w-[64px] justify-center border border-emerald-300 rounded bg-white px-1.5 py-0.5 font-semibold whitespace-nowrap">
																{reportTotalKg ? `Ort. ${formatMoney(reportAvgPrice)}` : ""}
															</span>
														</td>
														<td className="px-2 py-1.5 text-center bg-stone-100 border border-emerald-300 rounded-r-md">
															<span className="inline-flex min-w-[84px] justify-center border border-emerald-300 rounded bg-white px-1.5 py-0.5 font-black whitespace-nowrap">
																{formatMoney(reportTotalAmount)}
															</span>
														</td>
													</tr>
												</tbody>
											</table>
										</div>
									</div>
								</div>
							</div>

							<div className="w-[780px]">
								<div className="h-[350px] bg-white border border-emerald-300 rounded-2xl shadow-sm overflow-hidden flex flex-col">
									<div className="border-b border-emerald-300 bg-stone-50 px-3 py-2.5 flex items-center justify-between gap-2">
										<h1 className="text-base font-black text-stone-800">Gunluk Rapor</h1>
										<div className="flex items-center gap-1">
											<button
												type="button"
												onClick={handlePrevDailyReportDate}
												className="rounded border border-stone-300 bg-white px-1.5 py-0.5 text-[10px] font-bold text-stone-700 hover:bg-stone-50 transition"
												title="Geçmiş güne git"
											>
												◀
											</button>
											<input
												type="date"
												value={dailyReportDate}
												onChange={(e) => setDailyReportDate(e.target.value)}
												className="w-[120px] rounded border border-stone-300 bg-white px-1.5 py-0.5 text-[10px] focus:outline-none focus:ring-1 focus:ring-green-600"
											/>
											<button
												type="button"
												onClick={handleTodayDailyReportDate}
												className="rounded border border-emerald-300 bg-emerald-50 px-1.5 py-0.5 text-[10px] font-bold text-emerald-700 hover:bg-emerald-100 transition"
											>
												Tarih
											</button>
										</div>
									</div>

									<div className="flex-1 p-3">
										<div className="h-full w-full rounded-md border border-emerald-300 overflow-hidden bg-gradient-to-b from-emerald-50/40 to-white">
											<table className="w-full h-full table-fixed text-[11px] border-collapse">
												<thead className="bg-stone-50 text-stone-600">
													<tr className="h-[14.285%]">
														<th className="w-[90px] text-center px-2 py-1.5 border border-emerald-200">Sinif</th>
														<th className="text-center px-2 py-1.5 border border-emerald-200">Trilya</th>
														<th className="text-center px-2 py-1.5 border border-emerald-200">Edremit</th>
														<th className="text-center px-2 py-1.5 border border-emerald-200">Uslu</th>
														<th className="text-center px-2 py-1.5 border border-emerald-200">Domat</th>
														<th className="text-center px-2 py-1.5 border border-emerald-200">Tekir</th>
													</tr>
												</thead>
												<tbody className="text-stone-700">
													{dailyClassTypeRows.map((row) => (
														<tr key={`daily-class-${row.name}`} className="h-[14.285%] bg-emerald-50/70">
															<td className="px-2 py-1.5 text-center font-semibold border border-emerald-200">{row.name}</td>
															{row.values.map((value, idx) => (
																<td key={`daily-value-${row.name}-${oliveTypes[idx]}`} className="px-2 py-1.5 text-center font-semibold border border-emerald-200">
																	{value || ""}
																</td>
															))}
														</tr>
													))}
												</tbody>
											</table>
										</div>
									</div>
								</div>
							</div>

						</div>
					)}

					{currentTabKey === "gider" && (
						<div className="flex flex-wrap items-start content-start gap-3 -mt-1 -ml-1">
							<div className="w-[220px]">
								<div className="h-[350px] bg-white border border-stone-200 rounded-2xl shadow-sm overflow-hidden flex flex-col">
									<div className="border-b border-stone-200 bg-stone-50 px-3 py-2.5">
										<h1 className="text-base font-black text-stone-800">Otomatik Kayıt</h1>
									</div>
									<div className="flex-1 p-2.5 flex flex-col gap-2 overflow-hidden">
										{lastAutoSave ? (
											<div className="rounded-lg border border-green-200 bg-green-50 px-2.5 py-2 text-[10px] space-y-1">
												<div className="text-stone-500">Son otomatik kayıt günü</div>
												<div className="font-bold text-green-700 text-[11px] break-words">{formatAutoSaveDateTime(lastAutoSave)}</div>
												<div className="text-stone-500 text-[9px] leading-tight">
													{(savedSnapshot?.sellers?.length || 0)} satıcı · {(savedSnapshot?.deliveries?.length || 0)} teslim · {(savedSnapshot?.teslimatlar?.length || 0)} teslimat · {(savedSnapshot?.expenses?.length || 0)} gider
												</div>
												{lastPeriodicSaveAt && (
													<div className="mt-1 pt-1 border-t border-green-200">
														<div className="text-stone-400 text-[9px]">Periyodik kayıt</div>
														<div className="font-semibold text-green-600 text-[10px]">{formatPeriodicSaveTime(lastPeriodicSaveAt)}</div>
													</div>
												)}
											</div>
										) : (
											<div className="rounded-lg border border-stone-200 bg-stone-50 px-2.5 py-2 text-[10px] text-stone-400 leading-tight">
												Henüz otomatik kayıt yok.
											</div>
										)}
										<div className="mt-auto space-y-2">
											<button
												type="button"
												onClick={handleRestoreAutoSave}
												disabled={!lastAutoSave}
												className="w-full rounded-md bg-green-700 text-white px-3 py-2 text-[11px] font-bold hover:bg-green-800 transition disabled:opacity-40 disabled:cursor-not-allowed"
											>
												Geri Yükle
											</button>
											<button
												type="button"
												onClick={handleManualSave}
												className="w-full rounded-md border border-stone-300 bg-white text-stone-700 px-3 py-2 text-[11px] font-bold hover:bg-stone-50 transition"
											>
												Şimdi Kaydet
											</button>
										</div>
									</div>
								</div>
							</div>

						{/* Mevcut Teslimatlar Tablosu (canlı) */}
						{teslimatlar.length > 0 && (
							<div className="w-full xl:w-[460px]">
								<div className="bg-white border border-stone-200 rounded-2xl shadow-sm overflow-hidden">
									<div className="border-b border-stone-200 bg-stone-50 px-3 py-2.5 flex items-center justify-between">
										<h2 className="text-base font-black text-stone-800">Teslimat Kayıtları</h2>
										<span className="text-[10px] bg-stone-100 text-stone-600 rounded-full px-2 py-0.5">{teslimatlar.length} kayıt</span>
									</div>
									<div className="p-2 max-h-[400px] overflow-y-auto">
										<div className="rounded-md border border-stone-200 overflow-hidden">
											<table className="w-full text-[11px]">
												<thead className="bg-stone-50 text-stone-600 sticky top-0">
													<tr>
														<th className="px-2 py-1.5 text-left border-b border-stone-200">Firma</th>
														<th className="px-2 py-1.5 text-center border-b border-stone-200">Çeşit</th>
														<th className="px-2 py-1.5 text-center border-b border-stone-200">Kasa</th>
														<th className="px-2 py-1.5 text-center border-b border-stone-200">Kg</th>
													</tr>
												</thead>
												<tbody className="text-stone-700">
													{teslimatlar.map((t) => (
														<tr key={t.id} className="border-t border-stone-100">
															<td className="px-2 py-1.5 font-semibold">{t.firma}</td>
															<td className="px-2 py-1.5 text-center">{t.cesit || "-"}</td>
															<td className="px-2 py-1.5 text-center">{t.kasa || "-"}</td>
															<td className="px-2 py-1.5 text-center">{t.kg || "-"}</td>
														</tr>
													))}
												</tbody>
											</table>
										</div>
									</div>
								</div>
							</div>
						)}

					</div>
				)}

				{currentTabKey === "hesap" && isHistoryOpen && selectedSeller && (
					<div className="absolute inset-0 z-10 bg-white p-4 md:p-6 overflow-y-auto">
						<div className="max-w-md">
							<div className="flex items-start justify-between gap-4 border-b border-stone-200 pb-3">
								<div>
									<div className="text-xs uppercase tracking-widest bg-green-100 text-green-700 inline-block px-3 py-1 rounded-full">
										Panel Menu
									</div>
									<h2 className="text-lg font-black text-stone-800 mt-3">{selectedSeller.name}</h2>
									<div className="text-xs text-stone-500 mt-1">
										Toplam Kilo: {selectedSellerHistory.reduce((sum, item) => sum + item.kg, 0)} kg
									</div>
								</div>
								<button
									type="button"
									onClick={() => setIsHistoryOpen(false)}
									className="rounded-lg border border-stone-300 px-3 py-1.5 text-xs font-bold text-stone-700 hover:bg-stone-50 transition"
								>
									Kapat
								</button>
							</div>

							<div className="mt-4 rounded-2xl border border-stone-200 overflow-hidden max-w-md">
								<table className="w-full text-xs">
									<thead className="bg-stone-50 text-stone-600">
										<tr>
											<th className="text-center px-3 py-2.5">Tarih</th>
											<th className="text-center px-3 py-2.5">Cinsi</th>
											<th className="text-center px-3 py-2.5">Kilo</th>
											<th className="text-center px-3 py-2.5">Odenen</th>
										</tr>
									</thead>
									<tbody>
										{selectedSellerHistory.map((item, index) => (
											<tr key={`${selectedSeller.id}-${item.date}-${index}`} className="border-t border-stone-100">
												<td className="px-3 py-2.5">{item.date}</td>
												<td className="px-3 py-2.5">{item.type}</td>
												<td className="px-3 py-2.5 text-right font-semibold">{item.kg}</td>
												<td className="px-3 py-2.5 text-right">{item.paid}</td>
											</tr>
										))}
										{selectedSellerHistory.length === 0 && (
											<tr>
												<td colSpan="4" className="px-3 py-8 text-center text-stone-400">
													Bu satıcı için geçmiş zeytin dökümü bulunmuyor.
												</td>
											</tr>
										)}
									</tbody>
								</table>
							</div>
						</div>
					</div>
				)}

				{currentTabKey === "admin" && isAdmin && (
					<div className="flex flex-col" style={{minHeight: 'calc(100vh - 3rem)'}}>
						{/* Başlık */}
						<div className="flex items-center justify-between pb-4 border-b border-stone-200 mb-4">
							<div>
								<div className="text-xs uppercase tracking-widest bg-yellow-100 text-yellow-700 inline-block px-3 py-1 rounded-full mb-1">Admin Paneli</div>
								<h1 className="text-lg font-black text-stone-800">Üye Yönetimi</h1>
							</div>
							{adminView === "list" && (
								<button
									type="button"
									onClick={() => setAdminView("addMember")}
									className="rounded-xl bg-green-700 text-white px-4 py-2 text-sm font-bold hover:bg-green-800 transition"
								>
									+ Yeni Üye
								</button>
							)}
							{adminView !== "list" && (
								<button
									type="button"
									onClick={() => { setAdminView("list"); setSelectedAdminMemberId(null); setMemberForm({ name: "", phone: "", email: "" }); setPaymentAmount(""); setPaymentDays(""); }}
									className="rounded-xl border border-stone-300 bg-white text-stone-700 px-4 py-2 text-sm font-bold hover:bg-stone-50 transition"
								>
									← Geri
								</button>
							)}
						</div>

						{/* ÜYE LİSTESİ */}
						{adminView === "list" && (
							<div className="flex flex-col rounded-2xl border border-stone-200 bg-white shadow-sm overflow-hidden" style={{minHeight: 'calc(100vh - 180px)'}}>
								<div className="border-b border-stone-200 bg-stone-50 px-4 py-3 flex items-center justify-between shrink-0">
									<span className="font-bold text-stone-700 text-sm">Kayıtlı Üyeler</span>
									<span className="text-xs bg-stone-200 text-stone-600 rounded-full px-2 py-0.5">{members.length} üye</span>
								</div>
								<div className="flex-1 overflow-y-auto">
									<table className="w-full text-[12px]">
										<thead className="bg-stone-50 text-stone-500 text-[11px] uppercase sticky top-0">
											<tr>
												<th className="text-left px-4 py-2.5 border-b border-stone-200">Ad Soyad</th>
												<th className="text-left px-4 py-2.5 border-b border-stone-200">Telefon</th>
												<th className="text-left px-4 py-2.5 border-b border-stone-200">E-posta</th>
												<th className="text-center px-4 py-2.5 border-b border-stone-200">Kayıt Tarihi</th>
												<th className="text-center px-4 py-2.5 border-b border-stone-200">Bitiş Tarihi</th>
												<th className="text-center px-4 py-2.5 border-b border-stone-200">Durum</th>
												<th className="text-center px-4 py-2.5 border-b border-stone-200">İşlem</th>
											</tr>
										</thead>
										<tbody>
											{members.length === 0 && (
												<tr>
													<td colSpan="7" className="px-4 py-16 text-center text-stone-400 text-sm">
														Henüz kayıtlı üye yok.
													</td>
												</tr>
											)}
											{members.map((member) => {
												const status = getMemberStatus(member);
												return (
													<tr key={member.id} className="border-t border-stone-100 hover:bg-stone-50 transition">
														<td className="px-4 py-2.5 font-semibold text-stone-800">{member.name}</td>
														<td className="px-4 py-2.5 text-stone-600">{member.phone}</td>
														<td className="px-4 py-2.5 text-stone-500">{member.email || "-"}</td>
														<td className="px-4 py-2.5 text-center text-stone-500">
															{new Date(member.registeredAt).toLocaleDateString("tr-TR")}
														</td>
														<td className="px-4 py-2.5 text-center text-stone-500">
															{member.expiresAt ? new Date(member.expiresAt).toLocaleDateString("tr-TR") : "-"}
														</td>
														<td className={`px-4 py-2.5 text-center font-semibold ${status.color}`}>
															{status.label}
														</td>
														<td className="px-4 py-2.5 text-center">
															<div className="flex items-center justify-center gap-1.5">
																<button
																	type="button"
																	onClick={() => { setSelectedAdminMemberId(member.id); setAdminView("payment"); }}
																	className="rounded-md bg-green-700 text-white px-2.5 py-1 text-[11px] font-bold hover:bg-green-800 transition"
																>
																	Ödeme Ekle
																</button>
																<button
																	type="button"
																	onClick={() => handleDeleteMember(member.id)}
																	className="rounded-md border border-red-200 text-red-500 px-2 py-1 text-[11px] font-bold hover:bg-red-50 transition"
																>
																	Sil
																</button>
															</div>
														</td>
													</tr>
												);
											})}
										</tbody>
									</table>
								</div>
							</div>
						)}

						{/* YENİ ÜYE FORMU */}
						{adminView === "addMember" && (
							<div className="bg-white rounded-2xl border border-stone-200 shadow-sm p-6 max-w-md">
								<h2 className="font-black text-stone-800 text-base mb-4">Yeni Üye Ekle</h2>
								<div className="space-y-3">
									<div>
										<div className="text-xs font-semibold text-stone-600 mb-1">Ad Soyad *</div>
										<input type="text" value={memberForm.name} onChange={(e) => setMemberForm((f) => ({ ...f, name: e.target.value }))} className="w-full rounded-lg border border-stone-300 px-3 py-2 text-sm outline-none focus:ring-2 focus:ring-green-600" placeholder="Adı ve soyadı girin" />
									</div>
									<div>
										<div className="text-xs font-semibold text-stone-600 mb-1">Telefon *</div>
										<input type="text" value={memberForm.phone} onChange={(e) => setMemberForm((f) => ({ ...f, phone: e.target.value }))} className="w-full rounded-lg border border-stone-300 px-3 py-2 text-sm outline-none focus:ring-2 focus:ring-green-600" placeholder="05xx xxx xx xx" />
									</div>
									<div>
										<div className="text-xs font-semibold text-stone-600 mb-1">E-posta</div>
										<input type="text" value={memberForm.email} onChange={(e) => setMemberForm((f) => ({ ...f, email: e.target.value }))} className="w-full rounded-lg border border-stone-300 px-3 py-2 text-sm outline-none focus:ring-2 focus:ring-green-600" placeholder="ornek@mail.com" />
									</div>
									<button type="button" onClick={handleAddMember} className="w-full rounded-xl bg-green-700 text-white py-2.5 text-sm font-bold hover:bg-green-800 transition">
										Üye Ekle
									</button>
								</div>
							</div>
						)}

						{/* ÖDEME FORMU */}
						{adminView === "payment" && selectedAdminMemberId && (() => {
							const member = members.find((m) => m.id === selectedAdminMemberId);
							if (!member) return null;
							const status = getMemberStatus(member);
							return (
								<div className="space-y-4 max-w-md">
									<div className="bg-white rounded-2xl border border-stone-200 shadow-sm p-5">
										<div className="flex items-center gap-3 mb-4 pb-3 border-b border-stone-100">
											<div>
												<div className="font-black text-stone-800 text-base">{member.name}</div>
												<div className="text-xs text-stone-500 mt-0.5">{member.phone}{member.email ? ` · ${member.email}` : ""}</div>
											</div>
											<span className={`ml-auto text-xs font-bold ${status.color}`}>{status.label}</span>
										</div>
										<h2 className="font-bold text-stone-700 text-sm mb-3">Ödeme Ekle</h2>
										<div className="space-y-3">
											<div>
												<div className="text-xs font-semibold text-stone-600 mb-1">Ödeme Tutarı (TL)</div>
												<input type="number" min="0" value={paymentAmount} onChange={(e) => setPaymentAmount(e.target.value)} className="w-full rounded-lg border border-stone-300 px-3 py-2 text-sm outline-none focus:ring-2 focus:ring-green-600" placeholder="ör: 500" />
											</div>
											<div>
												<div className="text-xs font-semibold text-stone-600 mb-1">Üyelik Süresi (Gün)</div>
												<input type="number" min="1" value={paymentDays} onChange={(e) => setPaymentDays(e.target.value)} className="w-full rounded-lg border border-stone-300 px-3 py-2 text-sm outline-none focus:ring-2 focus:ring-green-600" placeholder="ör: 30" />
											</div>
											<button type="button" onClick={handleAddPayment} className="w-full rounded-xl bg-green-700 text-white py-2.5 text-sm font-bold hover:bg-green-800 transition">
												Ödemeyi Kaydet
											</button>
										</div>
									</div>
									{member.payments && member.payments.length > 0 && (
										<div className="bg-white rounded-2xl border border-stone-200 shadow-sm overflow-hidden">
											<div className="border-b border-stone-200 bg-stone-50 px-4 py-2.5">
												<span className="font-bold text-stone-700 text-sm">Ödeme Geçmişi</span>
											</div>
											<table className="w-full text-xs">
												<thead className="bg-stone-50 text-stone-500">
													<tr>
														<th className="text-center px-3 py-2">Tarih</th>
														<th className="text-center px-3 py-2">Tutar</th>
														<th className="text-center px-3 py-2">Süre</th>
													</tr>
												</thead>
												<tbody>
													{member.payments.map((p) => (
														<tr key={p.id} className="border-t border-stone-100">
															<td className="px-3 py-2 text-center text-stone-500">{new Date(p.paidAt).toLocaleDateString("tr-TR")}</td>
															<td className="px-3 py-2 text-center font-semibold text-green-700">{p.amount.toLocaleString("tr-TR")} TL</td>
															<td className="px-3 py-2 text-center text-stone-600">{p.durationDays} gün</td>
														</tr>
													))}
												</tbody>
											</table>
										</div>
									)}
								</div>
							);
						})()}
					</div>
				)}

				</div>
			</div>
		</div>
	);
}
